var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1178_10367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99993 15.7143C12.2604 15.7143 15.7142 12.2605 15.7142 8.00001C15.7142 3.73952 12.2604 0.285721 7.99993 0.285721C3.73945 0.285721 0.285645 3.73952 0.285645 8.00001C0.285645 12.2605 3.73945 15.7143 7.99993 15.7143Z",
    fill: "#FBD38D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16C3.58857 16 0 12.4114 0 8C0 3.58857 3.58857 0 8 0C12.4114 0 16 3.58857 16 8C16 12.4114 12.4114 16 8 16ZM8 0.571429C3.90476 0.571429 0.571429 3.90476 0.571429 8C0.571429 12.0952 3.90476 15.4286 8 15.4286C12.0952 15.4286 15.4286 12.0952 15.4286 8C15.4286 3.90476 12.0952 0.571429 8 0.571429Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99986 1.15999C11.996 1.15999 15.2646 4.33333 15.4208 8.29333C15.4246 8.19428 15.4284 8.09714 15.4284 7.99809C15.4284 3.90095 12.097 0.567612 7.99986 0.567612C3.90272 0.567612 0.571289 3.90095 0.571289 7.99618C0.571289 8.09523 0.575099 8.19428 0.578908 8.29142C0.735099 4.33333 4.00367 1.15999 7.99986 1.15999Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.20361 11.5486C7.20361 11.2838 7.27409 11.0838 7.41314 10.9467C7.55218 10.8095 7.75028 10.7409 8.00742 10.7409C8.26457 10.7409 8.45504 10.8114 8.59218 10.9543C8.72933 11.0971 8.79599 11.2952 8.79599 11.5486C8.79599 11.8019 8.72742 12.0038 8.59028 12.1505C8.45314 12.2971 8.25885 12.3733 8.00933 12.3733C7.7598 12.3733 7.5579 12.3029 7.41695 12.16C7.27599 12.0171 7.20552 11.8133 7.20552 11.5486H7.20361ZM8.4779 9.83999H7.54647L7.30076 4.36571C7.28171 3.9619 7.60552 3.62476 8.00933 3.62476C8.41314 3.62476 8.73695 3.9619 8.7179 4.36571L8.4779 9.83999Z",
    fill: "#1A202C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1178_10367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.0e06553df8293cb42783634cf71cc518.svg";
export { ForwardRef as ReactComponent };